import { render, staticRenderFns } from "./Restricted404.vue?vue&type=template&id=126fb420&scoped=true"
import script from "./Restricted404.vue?vue&type=script&lang=js"
export * from "./Restricted404.vue?vue&type=script&lang=js"
import style0 from "./Restricted404.vue?vue&type=style&index=0&id=126fb420&prod&scss=true&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126fb420",
  null
  
)

export default component.exports